import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
 
Vue.component('apexchart', VueApexCharts);